<template>
  <button
    v-if="summary.count > 0"
    type="button"
    class="nota-comercial-pending-badge text-primary"
    :title="tooltip"
    :aria-label="tooltip"
    @click.stop.prevent="openPopup"
  >
    <i class="fas fa-file-invoice-dollar" aria-hidden="true"></i>
    <span v-if="summary.count > 1" class="nota-comercial-pending-badge__count">{{ summary.count }}</span>
  </button>
</template>

<script>
import { pendingNotesForContact } from "../utils/notaComercialPendingContacts";
import { showNotaComercialPendingPopup } from "../utils/notaComercialPendingPopup";

/**
 * Aviso de notas comerciales con saldo sin aplicar para un contacto.
 * Va al lado del nombre del cliente o del proveedor: si el contacto no tiene ninguna,
 * no renderiza nada. Al hacer click abre el detalle de esas notas.
 */
export default {
  name: "NotaComercialPendingBadge",
  props: {
    /** Contacto a mirar (cliente, proveedor o el contacto de un gasto). */
    contactId: {
      type: String,
      default: "",
    },
    /** Nombre del contacto, para encabezar el popup. Opcional. */
    contactName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      summary: { count: 0, total: 0, notes: [] },
    };
  },
  computed: {
    tooltip() {
      const head = this.$t("notaComercial.pending.badgeTitle", {
        count: this.summary.count,
        amount: this.formatAmount(this.summary.total),
      });
      return `${head}\n${this.$t("notaComercial.pending.badgeHint")}`;
    },
  },
  watch: {
    contactId: {
      immediate: true,
      handler() {
        this.load();
      },
    },
  },
  methods: {
    async load() {
      const id = String(this.contactId || "").trim();
      if (!id) {
        this.summary = { count: 0, total: 0, notes: [] };
        return;
      }
      const summary = await pendingNotesForContact(id);
      // Entre el pedido y la respuesta el contacto pudo cambiar (misma fila, otro registro).
      if (String(this.contactId || "").trim() !== id) return;
      this.summary = summary && summary.count ? summary : { count: 0, total: 0, notes: [] };
    },
    openPopup() {
      if (!this.summary.count) return;
      showNotaComercialPendingPopup(this.summary, {
        contactName: this.contactName,
        t: (key, params) => this.$t(key, params),
      });
    },
    formatAmount(value) {
      const n = Number(value) || 0;
      return n.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style scoped>
.nota-comercial-pending-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
  font-size: 0.8em;
  line-height: 1;
  white-space: nowrap;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.nota-comercial-pending-badge__count {
  font-size: 0.75em;
  font-weight: 600;
}
</style>
